module.exports = __webpack_public_path__ + "static/media/README.4b2435c0.md";